/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/segments-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/segments-api-client";
import type { StationStatusGetStatusesQueryResponse, StationStatusGetStatusesQueryParams } from "../models/StationStatusGetStatuses";

export function getStationStatusGetStatusesUrl() {
  const res = { method: 'GET', url: `/status` as const }  
  return res
}

/**
 * @description Returns status (online/offline) and recent segments info for stations. A station is online if it has recorded a segment in the past threshold seconds. Includes latestAt (ISO string) indicating the most recent segment endTs. If ids query parameter is provided, returns status for those specific stations. If omitted, returns status for all stations of the client.
 * @summary Get status for stations
 * {@link /status}
 */
export async function stationStatusGetStatuses(params?: StationStatusGetStatusesQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<StationStatusGetStatusesQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getStationStatusGetStatusesUrl().url.toString(), params, ... requestConfig })  
  return res.data
}